import React, { FC, ReactElement, RefObject, useState } from 'react'
import { Button, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import { ButtonVariant } from 'react-bootstrap/types'

export interface AppAsyncButtonProps {
  isLoading?: boolean
  disabled?: boolean
  loadingText?: string
  buttonText?: string
  onClick: ((e?: any) => void) | (() => Promise<void>)
  buttonVariant?: ButtonVariant
  className?: string
  buttonChild?: ReactElement
  buttonSize?: 'sm' | 'lg'
  tooltip?: string
  disabledTooltip?: string
  style?: any
  reference?: RefObject<HTMLButtonElement>
}

const AppButton: FC<AppAsyncButtonProps> = ({
  isLoading,
  disabled,
  onClick,
  loadingText,
  buttonText,
  buttonVariant,
  className,
  buttonChild,
  tooltip,
  disabledTooltip,
  buttonSize,
  style,
  reference,
}) => {
  const [clicked, setClicked] = useState<boolean>(false)

  const onButtonClick = async (e: any) => {
    const result = onClick(e)

    if (result instanceof Promise) {
      try {
        setClicked(true)
        await result
        setClicked(false)
      } catch (error) {
        setClicked(false)
      }
    }
  }

  const renderButton = () => (
    <Button
      disabled={isLoading || disabled || clicked}
      onClick={(e) => onButtonClick(e)}
      variant={disabled ? 'outline-' + buttonVariant : buttonVariant}
      className={className}
      size={buttonSize}
      style={style}
      ref={reference}
    >
      {isLoading || clicked ? (
        <>
          {loadingText ||
            (buttonText && (
              <span className="me-2">
                {loadingText ? loadingText : buttonText ? buttonText : ''}
              </span>
            ))}
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        </>
      ) : (
        <>
          {buttonChild ? buttonChild : null}
          {buttonText ? '\t' + buttonText : null}
        </>
      )}
    </Button>
  )

  return disabled && disabledTooltip ? (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Tooltip id="button-tooltip-disabled">{disabledTooltip}</Tooltip>
      }
    >
      <span className="">{renderButton()}</span>
    </OverlayTrigger>
  ) : (
    <OverlayTrigger
      placement="bottom"
      overlay={
        tooltip ? <Tooltip id="button-tooltip">{tooltip}</Tooltip> : <></>
      }
    >
      <span className="">{renderButton()}</span>
    </OverlayTrigger>
  )
}

export default AppButton
